import { throwErrorMessage } from 'dashboard/store/utils/api';
import InteractiveMessageTemplateAPI from '../../api/interactiveMessageTemplate';

const state = {
    records: [],
    uiFlags: {
        fetchingList: false,
        creatingItem: false,
        updatingItem: false,
        deletingItem: false,
    },
};

const getters = {
    getTemplates(_state) {
        return _state.records;
    },
    getUIFlags(_state) {
        return _state.uiFlags;
    },
};

const SET_TEMPLATES = 'SET_INTERACTIVE_MSG_TEMPLATES';
const ADD_TEMPLATE = 'ADD_INTERACTIVE_MSG_TEMPLATE';
const EDIT_TEMPLATE = 'EDIT_INTERACTIVE_MSG_TEMPLATE';
const DELETE_TEMPLATE = 'DELETE_INTERACTIVE_MSG_TEMPLATE';
const SET_UI_FLAG = 'SET_INTERACTIVE_MSG_TEMPLATES_UI_FLAG';

const actions = {
    fetchTemplates: async ({ commit }, params = {}) => {
        commit(SET_UI_FLAG, { fetchingList: true });
        try {
            const response = await InteractiveMessageTemplateAPI.get(params);
            commit(SET_TEMPLATES, response.data);
        } catch (error) {
            // Ignore
        } finally {
            commit(SET_UI_FLAG, { fetchingList: false });
        }
    },

    createTemplate: async ({ commit }, data) => {
        commit(SET_UI_FLAG, { creatingItem: true });
        try {
            const response = await InteractiveMessageTemplateAPI.create(data);
            commit(ADD_TEMPLATE, response.data);
            return response.data;
        } catch (error) {
            return throwErrorMessage(error);
        } finally {
            commit(SET_UI_FLAG, { creatingItem: false });
        }
    },

    updateTemplate: async ({ commit }, { id, ...data }) => {
        commit(SET_UI_FLAG, { updatingItem: true });
        try {
            const response = await InteractiveMessageTemplateAPI.update(id, data);
            commit(EDIT_TEMPLATE, response.data);
            return response.data;
        } catch (error) {
            return throwErrorMessage(error);
        } finally {
            commit(SET_UI_FLAG, { updatingItem: false });
        }
    },

    deleteTemplate: async ({ commit }, id) => {
        commit(SET_UI_FLAG, { deletingItem: true });
        try {
            await InteractiveMessageTemplateAPI.delete(id);
            commit(DELETE_TEMPLATE, id);
            return id;
        } catch (error) {
            return throwErrorMessage(error);
        } finally {
            commit(SET_UI_FLAG, { deletingItem: false });
        }
    },
};

const mutations = {
    [SET_UI_FLAG](_state, data) {
        _state.uiFlags = { ..._state.uiFlags, ...data };
    },
    [SET_TEMPLATES](_state, data) {
        _state.records = data;
    },
    [ADD_TEMPLATE](_state, data) {
        _state.records.push(data);
    },
    [EDIT_TEMPLATE](_state, data) {
        const idx = _state.records.findIndex(r => r.id === data.id);
        if (idx !== -1) {
            _state.records.splice(idx, 1, data);
        }
    },
    [DELETE_TEMPLATE](_state, id) {
        _state.records = _state.records.filter(r => r.id !== id);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
